<template>
    <div class="slider-area" dir="ltr" data-cy="slider">
        <div class="bd-example">
            <div class="carousel slide" data-ride="carousel">
                <div class="carousel-inner" ref="slider">
                    <div class="image-slider position-relative" v-if="imageSlides?.length">
                        <Carousel :value="imageSlides" :numVisible="1" :numScroll="1" :circular="true"
                            class="custom-carousel" :autoplayInterval="interval" :showNavigators="false">
                            <template #item="slotProps">
                                <div
                                    class="d-flex position-relative slide-item justify-content-center justify-content-sm-end align-items-center pe-0 pe-sm-5 pt-5 pt-sm-0">
                                    <img v-if="imageSlides[0].image === slotProps.data?.image" fetchpriority="high"
                                        :src="slotProps.data?.image" :alt="slotProps.data?.name"
                                        class="position-absolute object-fit-cover w-100 h-100 h-100 start-0 end-0" />
                                    <img v-else fetchpriority="low" loading="lazy" :src="slotProps.data?.image"
                                        :alt="slotProps.data?.name"
                                        class="position-absolute object-fit-cover w-100 h-100 start-0 end-0" />
                                    <div
                                        class="summary d-flex flex-column align-items-center align-items-sm-end mt-sm-0 mb-xl-5 pb-xl-5">
                                        <div class="summary__text text-white mb-sm-3 fs-1">
                                            {{ slotProps.data?.name }}
                                        </div>
                                        <a v-if="showButtons" :href="slotProps.data?.url_link">
                                            <Button class="p-button-primary w-200 fw-light" label="تبرع الآن" />
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, computed, reactive, ref, onUpdated } from 'vue';

const props = defineProps({
    imageSlides: {
        type: Array,
        required: true
    },
    showButtons: {
        type: Boolean,
        default: true
    }
});

const state = reactive({
    sliderPaused: false,
});

const interval = computed(() => {
    return state.sliderPaused ? 99999999 : 4000;

});

const slider = ref(null);

const toggleSliderAutoplay = () => {
    state.sliderPaused = !state.sliderPaused;
    changePauseButtonIcon();
}

const changePauseButtonIcon = () => {
    const pauseBtnIcon = document.querySelector("#pause-button-icon");
    pauseBtnIcon.classList.contains("pi-pause")
        ? pauseBtnIcon.classList.remove("pi-pause")
        : pauseBtnIcon.classList.add("pi-pause");
    pauseBtnIcon.classList.contains("pi-play")
        ? pauseBtnIcon.classList.remove("pi-play")
        : pauseBtnIcon.classList.add("pi-play");
}
const createPauseButton = () => {
    if (!slider.value) return;

    const sliderNav = slider.value.querySelector(".p-carousel-indicators");
    if (!sliderNav) {
        state.foundSelectors = false;
        return;
    }

    const sliderNavItem = slider.value.querySelector(".p-carousel-indicator");
    if (!sliderNavItem) {
        state.foundSelectors = false;
        return;
    }

    state.foundSelectors = true;

    const pauseLi = document.createElement("li");
    const pauseBtn = document.createElement("button");
    const pauseIcon = document.createElement("i");

    sliderNav.classList.add("align-items-center");
    pauseBtn.classList.add("p-button", "p-button-rounded", "d-flex", "justify-content-center");

    pauseIcon.id = "pause-button-icon";
    pauseBtn.setAttribute("aria-label", "Play/Pause Slider");
    pauseIcon.classList.add("pi", "pi-pause");

    pauseBtn.style.backgroundColor = "rgba(255,255,255, 0.4)";
    pauseBtn.style.borderColor = "rgba(255,255,255, 0.4)";
    pauseBtn.style.width = "44px";
    pauseBtn.style.height = "25px";
    pauseBtn.style.marginRight = "15px";
    pauseBtn.style.marginBottom = "5px";

    pauseIcon.style.color = "#5581C4";
    pauseIcon.style.padding = "2px";
    pauseIcon.style.border = "2px solid #5581C4";
    pauseIcon.style.borderRadius = "50%";
    pauseIcon.style.fontSize = "10px";

    pauseBtn.appendChild(pauseIcon);
    pauseLi.appendChild(pauseBtn);

    pauseBtn.addEventListener("click", () => {
        toggleSliderAutoplay();
    });

    sliderNav.insertBefore(pauseLi, sliderNavItem);
};


onUpdated(() => {
    if (!state.foundSelectors) {
        createPauseButton();
    }
});
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/abstracts/mixins";

.slider-area {
    height: 550px;

    @include respond(xl) {
        height: 400px;
    }
}

.image-slider {
    &__pause {
        position: absolute;
        bottom: 0;
        left: 100px;
    }
}

.summary {
    z-index: 100;
    margin-top: 120px;
    text-shadow: rgba(black, 0.2) 1px 0 10px;

    &__text {
        margin-bottom: 15px;
    }

    .p-button {
        a {
            color: white;
            text-decoration: none;
        }
    }
}

@media (max-width: 768px) {
    :deep(.slide-item img) {
        width: auto !important;
    }
}

::v-deep(.slide-item) {
    width: 100%;
    height: 550px;
    position: relative;
    background-repeat: no-repeat !important;
    background-size: cover !important;

    @include respond(xl) {
        height: 400px;
    }
}

::v-deep(.p-carousel-indicators) {
    position: absolute;
    bottom: 0;
    margin: auto;
    width: 100%;
}

::v-deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
    width: 3rem !important;
    height: 0.3rem !important;
    border-radius: 8px;
}

::v-deep(.p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button) {
    background-color: $color-complementary;
}

.w-200 {
    width: 200px;
}

.p-button {
    height: 40px;
}
</style>